// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Link, useParams } from 'react-router-dom';
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import BlockUi from 'react-block-ui';
import MUIDataTable from "mui-datatables";
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from "../../../../redux/confirmModalRedux";
import DailyFormsListingTable from './_partials/forms/DailyFormsListingTable';
import OneTimeFormsListingTable from './_partials/forms/OneTimeFormsListingTable';
// SERVICES AND HELPERS
import * as jobFormService from "../../../../services/service/jobFormService";
import * as jobUploadFormService from "../../../../services/form/jobUploadFormService";
import * as plmDataSheetService from "../../../../services/form/plmDataSheetService";
import * as haplmDataSheetService from "../../../../services/form/haplmDataSheetService";
import * as dailyLogFormService from "../../../../services/form/dailyLogFormService";
import * as projectInfoSheetService from "../../../../services/form/projectInfoSheetService";
import * as leadInfoSheetService from "../../../../services/form/leadInfoSheetService";
import * as pcmChainOfCustodyService from '../../../../services/form/pcmChainOfCustodyService';
import * as leadAirChainOfCustodyService from '../../../../services/form/leadAirChainOfCustodyService';
import * as leadPaintChainOfCustodyService from '../../../../services/form/leadPaintChainOfCustodyService';
import * as leadTCLPChainOfCustodyService from '../../../../services/form/leadTCLPChainOfCustodyService';
import * as pcmDataSheetService from "../../../../services/form/pcmDataSheetService";
import * as leadAirDataSheetService from "../../../../services/form/leadAirDataSheetService";
import * as leadPaintDataSheetService from "../../../../services/form/leadPaintDataSheetService";
import * as leadTCLPDataSheetService from "../../../../services/form/leadTCLPDataSheetService";
import * as helper from "../../../../helpers/helper";
//STYLES AND ASSETS
import 'react-block-ui/style.css';

const JobFormsPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const { jobId } = useParams();
    const [loading, setLoading] = useState(false);
    const [dailyForms, setDailyForms] = useState([]);;
    const [oneTimeForms, setOneTimeForms] = useState([]);;

    useEffect(() => {
        fetchAllForms();
    }, [])

    const fetchAllForms = () => {
        setLoading(true);
        fetchJobForms();
    }

    const fetchJobForms = () => {
        jobFormService.getJobForms(jobId).then(res => {
            if (res.forms) {
                setDailyForms(res.forms.dailyForms);
                setOneTimeForms(res.forms.oneTimeForms);
            }
        }).finally(x => setLoading(false));
    }

    const determineAndStartForm = (model, edit) => {
        if (model.id === 0) {
            startNewForm(model);
            return;
        }
        if (model.formType === "UPLOAD") {
            history.push('/forms/job-upload-form/' + model.id);
        } else {
            history.push(helper.getRoutesForForm(model.name) + model.id + '/' + edit);
        }
    }

    const startNewForm = (model) => {
        const startModelDto = { ...model, jobId: jobId, date: model.date === "N/A" ? new Date() : model.date };

        if (model.formType === "UPLOAD") {
            jobUploadFormService.startUploadForm(startModelDto).then(res => {
                if (res) {
                    history.push('/forms/job-upload-form/' + res.jobFormId);
                }
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' });
            });
        } else {
            startNewBuiltInForm(model, startModelDto);
        }
    }

    const startNewBuiltInForm = (model, startModelDto) => {
        var formStartPromise = new Promise((resolve, reject) => { });
        if (model.name.includes("Project Information Sheet")) {
            formStartPromise = projectInfoSheetService.start(startModelDto)
        }
        if (model.name.includes("Lead Information Sheet")) {
            formStartPromise = leadInfoSheetService.start(startModelDto);
        }
        else {
            switch (model.name) {
                case "HA PLM Data Sheet":
                    formStartPromise = plmDataSheetService.start(startModelDto);
                    break;
                // case "HA PLM Data Sheet":
                //     formStartPromise = haplmDataSheetService.start(startModelDto);
                //     break;
                case "Daily Log Form":
                    formStartPromise = dailyLogFormService.start(startModelDto);
                    break;
                case "PCM-Air Data Sheet":
                    formStartPromise = pcmDataSheetService.start(startModelDto);
                    break;
                case "Lead-Air Data Sheet":
                    formStartPromise = leadAirDataSheetService.start(startModelDto);
                    break;
                case "Lead-Air Chain Of Custody":
                    formStartPromise = leadAirChainOfCustodyService.start(startModelDto);
                    break;
                case "Lead-Paint Chip Data Sheet":
                    formStartPromise = leadPaintDataSheetService.start(startModelDto);
                    break;
                case "Lead-Paint Chain Of Custody":
                    formStartPromise = leadPaintChainOfCustodyService.start(startModelDto);
                    break;
                case "Lead-TCLP Data Sheet":
                    formStartPromise = leadTCLPDataSheetService.start(startModelDto);
                    break;
                case "Lead-TCLP Chain Of Custody":
                    formStartPromise = leadTCLPChainOfCustodyService.start(startModelDto);
                    break;
                case "PCM Chain Of Custody":
                    formStartPromise = pcmChainOfCustodyService.start(startModelDto);
                    break;
                default:
                    break;
            }
        }

        formStartPromise.then(res => {
            if (res) {
                var formRoute = helper.getRoutesForForm(model.name);

                history.push(formRoute + res.jobFormId + '/' + true);
            }
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        });
    }

    const determineAndSetFormAsNA = (model) => {
        setProcessing();
        if (model.id === 0) {
            setNewFormAsNA(model)
        } else {
            hideConfirmModal();
            showAlert({ message: 'Started form cannot be set as NA as of right now', variant: 'info' });
        }
    }

    const unsubmitForm = (id) => {
        jobFormService.unsubmitForm(id).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            hideConfirmModal(true)
            fetchJobForms()
        }).catch(err => showAlert({ message: err.message, variant: 'error'}));
    }

    const setNewFormAsNA = (model) => {
        let naModel = { ...model, jobId: jobId, isNotApplicable: true,date: model.date === "N/A" ? new Date() : model.date };
        if (model.formType === "UPLOAD") {
            jobUploadFormService.startUploadForm(naModel).then(res => {         
                if (res) {
                    showAlert({ message: 'Success! Form set as Not Applicable', variant: 'success' });
                    fetchAllForms();
                }
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' });
                hideConfirmModal();
            }).finally(() => hideConfirmModal());
        } else {
            setNewBuiltInFormAsNA(naModel)
        }
    }

    const setNewBuiltInFormAsNA = (naModel) => {
        var formNAPromise = new Promise((resolve, reject) => { });
        if (naModel.name.includes("Project Information Sheet")) {
            formNAPromise = projectInfoSheetService.start(naModel);
        }
        if (naModel.name.includes("Lead Information Sheet")) {
            formNAPromise = leadInfoSheetService.start(naModel);
        }
        else {
            switch (naModel.name) {
                case "HA PLM Data Sheet":
                    formNAPromise = plmDataSheetService.start(naModel);
                    break;
                // case "HA PLM Data Sheet":
                //     formNAPromise = haplmDataSheetService.start(naModel);
                //     break;
                case "Daily Log Form":
                    formNAPromise = dailyLogFormService.start(naModel);
                    break;
                case "PCM-Air Data Sheet":
                    formNAPromise = pcmDataSheetService.start(naModel);
                    break;
                case "PCM Chain Of Custody":
                    formNAPromise = pcmChainOfCustodyService.start(naModel);
                    break;
                case "Lead-Air Data Sheet":
                    formNAPromise = leadAirDataSheetService.start(naModel);
                    break;
                case "Lead-Air Chain Of Custody":
                    formNAPromise = leadAirChainOfCustodyService.start(naModel);
                    break;
                case "Lead-Paint Chip Data Sheet":
                    formNAPromise = leadPaintDataSheetService.start(naModel);
                    break;
                case "Lead-Paint Chain Of Custody":
                    formNAPromise = leadPaintChainOfCustodyService.start(naModel);
                    break;
                case "Lead-TCLP Data Sheet":
                    formNAPromise = leadTCLPDataSheetService.start(naModel);
                    break;
                case "Lead-TCLP Chain Of Custody":
                    formNAPromise = leadTCLPChainOfCustodyService.start(naModel);
                    break;
                default:
                    break;
            }
        }

        formNAPromise.then(res => {
            if (res) {
                showAlert({ message: 'Success! Form set as Not Applicable', variant: 'success' });
                fetchAllForms();
            }
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
            hideConfirmModal();
        }).finally(() => hideConfirmModal());
    }

    return (
        <div className="col-lg-12 col-xxl-12 mb-10">
            <div className={`card card-custom card-stretch gutter-b`}>
                {loading && <ModalProgressBar />}
                <div className="card-header py-3 mb-10">
                    <div className="card-title align-items-start flex-column">
                        <h3 className="card-label font-weight-bolder text-dark">
                            Job Forms
                        </h3>
                        <span className="text-muted font-weight-bold fz-xs mt-1">
                            View/edit forms for this job  Please make sure job start and end date is selected. Also, make sure that form lead is selected for this job.
                        </span>
                    </div>
                    <div className="card-toolbar">
                        <Link
                            to="/services/jobs"
                            className="btn btn-secondary"
                        >
                            Cancel
                        </Link>
                    </div>
                </div>

                <BlockUi tag="div" blocking={loading}>
                    <div className="container-fluid mb-10">
                        <DailyFormsListingTable
                            {...props}
                            dailyForms={dailyForms}
                            showConfirmModal={showConfirmModal}
                            determineAndStartForm={determineAndStartForm}
                            determineAndSetFormAsNA={determineAndSetFormAsNA}
                            unsubmitForm = {unsubmitForm}
                        />

                        <OneTimeFormsListingTable
                            {...props}
                            oneTimeForms={oneTimeForms}
                            showConfirmModal={showConfirmModal}
                            determineAndStartForm={determineAndStartForm}
                            determineAndSetFormAsNA={determineAndSetFormAsNA}
                            unsubmitForm = {unsubmitForm}
                        />
                        {/* 
                        <AsNeededFormsListingTable
                            {...props}
                            onDemandForms={asNeededForms}
                            fetchOneTimeAndAsNeededForms={fetchOneTimeAndAsNeededForms}
                            showConfirmModal={showConfirmModal}
                            determineAndStartForm={determineAndStartForm}
                            determineAndSetFormAsNA={determineAndSetFormAsNA}
                        /> */}
                    </div>
                </BlockUi>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(JobFormsPage);